import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { DownloadIcon } from 'lucide-react';
export function AlgemeneVoorwaardenPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-705">
      <SEO title="Algemene Voorwaarden | Noord Digital" description="Lees de algemene voorwaarden en Service Level Agreement (SLA) van Noord Digital." data-id="element-706" />
      <Header data-id="element-707" />

      <main className="pt-32 pb-20" data-id="element-708">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[900px]" data-id="element-709">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-12 gap-6" data-id="element-710">
            <h1 className="text-4xl md:text-5xl font-bold text-[#111827]" data-id="element-711">
              Algemene Voorwaarden
            </h1>
            <a href="#" className="inline-flex items-center justify-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap" data-id="element-712">
              <DownloadIcon className="w-5 h-5 mr-2" data-id="element-713" />
              Download PDF
            </a>
          </div>

          <div className="prose prose-lg max-w-none prose-headings:text-[#111827] prose-a:text-[#007AFF] prose-p:text-[#6B7280] prose-li:text-[#6B7280]" data-id="element-714">
            <h2 className="text-3xl font-bold mt-12 mb-6 border-b pb-4" data-id="element-715">
              ALGEMENE VOORWAARDEN EN SLA
            </h2>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-716">
              Artikel 1 – Definities
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-717">
              <li data-id="element-718">
                <strong data-id="element-719">Noord Digital:</strong> de vennootschap onder firma
                Noord Digital, gevestigd te Oudkarspel, ingeschreven bij de KvK
                onder nummer 96071044.
              </li>
              <li data-id="element-720">
                <strong data-id="element-721">Opdrachtgever of klant:</strong> iedere natuurlijke
                persoon of rechtspersoon die diensten van Noord Digital afneemt
                of met Noord Digital een overeenkomst sluit.
              </li>
              <li data-id="element-722">
                <strong data-id="element-723">Partijen:</strong> gezamenlijk Noord Digital en de
                Opdrachtgever.
              </li>
              <li data-id="element-724">
                <strong data-id="element-725">Diensten:</strong> alle door Noord Digital aangeboden
                werkzaamheden en services, waaronder webdesign,
                websiteontwikkeling, WordPress- en Elementor-websites, hosting,
                onderhoud, SEO-optimalisatie, e-mailhosting, domeinregistratie,
                branding, API-ontwikkeling, AI-workflows en
                software-implementaties.
              </li>
              <li data-id="element-726">
                <strong data-id="element-727">Overeenkomst:</strong> het geheel van schriftelijke
                afspraken tussen Partijen, bestaande uit (i) de door
                Opdrachtgever ondertekende offerte of opdrachtbevestiging, (ii)
                deze Algemene Voorwaarden, en (iii) alle aan de Opdrachtgever
                geleverde documenten en materialen die onderdeel uitmaken van de
                opdracht.
              </li>
              <li data-id="element-728">
                <strong data-id="element-729">Schriftelijk:</strong> omvat alle vormen van
                communicatie per e-mail of elektronische handtekening. Een
                elektronische handtekening die voldoet aan de eIDAS-verordening
                (Verordening (EU) 910/2014) wordt geacht een handgeschreven
                handtekening te zijn.
              </li>
              <li data-id="element-730">
                <strong data-id="element-731">Werkdag:</strong> elke dag van maandag tot en met
                vrijdag, uitgezonderd officiële Nederlandse feestdagen.
              </li>
            </ul>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-732">
              Artikel 2 – Toepasselijkheid
            </h3>
            <p data-id="element-733">
              Deze Algemene Voorwaarden zijn van toepassing op alle offertes,
              aanbiedingen, werkzaamheden en overeenkomsten tussen Noord Digital
              en de Opdrachtgever. Dat geldt ook indien tussentijds (na
              totstandkoming) een of meerdere aanvullende verklaringen door
              partijen zijn ondertekend; de oorspronkelijke voorwaarden blijven
              leidend.
            </p>
            <p data-id="element-734">
              Wijzigingen of aanvullingen op deze voorwaarden gelden slechts
              indien uitdrukkelijk schriftelijk overeengekomen. Tegenstrijdige
              voorwaarden van de Opdrachtgever worden hierbij uitdrukkelijk van
              de hand gewezen. Indien de Opdrachtgever zich niet akkoord
              verklaart met deze Algemene Voorwaarden, dient hij dit
              onmiddellijk, maar uiterlijk bij ondertekening van de offerte of
              opdrachtbevestiging aan Noord Digital te melden.
            </p>
            <p data-id="element-735">
              De Opdrachtgever verklaart bij het aangaan van de Overeenkomst
              kennis te hebben genomen van deze Algemene Voorwaarden en hiermee
              akkoord te gaan. Indien partijen een digitaal offerte- of
              ondertekeningsproces gebruiken, moet de Opdrachtgever via een
              expliciete klik of handtekening bevestigen dat hij de Algemene
              Voorwaarden heeft ontvangen (bijvoorbeeld als pdf) en kan opslaan
              voor latere raadpleging. Alleen op deze wijze is voldaan aan de
              eis dat voorwaarden vóór of bij contractsluiting kenbaar en "ter
              hand gesteld" moeten worden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-736">
              Artikel 3 – Offertes en totstandkoming van de Overeenkomst
            </h3>
            <p data-id="element-737">
              Alle offertes en prijsopgaven van Noord Digital zijn vrijblijvend,
              tenzij uitdrukkelijk anders vermeld. Een offerte bevat een
              omschrijving van de overeengekomen werkzaamheden, tarieven en –
              indien van toepassing – oplevertermijn.
            </p>
            <p data-id="element-738">
              Een Overeenkomst komt uitsluitend tot stand op het moment dat: (i)
              de Opdrachtgever de offerte of opdracht schriftelijk accepteert
              (bijvoorbeeld door ondertekening of elektronische bevestiging),
              (ii) Noord Digital de opdracht schriftelijk bevestigt, of (iii)
              Noord Digital met de uitvoering van werkzaamheden aanvangt. Het is
              niet vereist dat de Opdrachtgever de inhoud van de Algemene
              Voorwaarden leest voordat hij akkoord gaat. Wel moeten de Algemene
              Voorwaarden bij contractsluiting als bijlage of hyperlink
              beschikbaar zijn gesteld zodat de Opdrachtgever ze kan downloaden
              en bewaren (art. 6:235 BW). Bij digitale totstandkoming
              (bijvoorbeeld online opdrachtbevestiging) dient dit via een
              duidelijk herkenbare link of pdf bij de Overeenkomst te
              geschieden.
            </p>
            <p data-id="element-739">
              Indien een offerte of opdrachtbevestiging handelt over
              verschillende deelonderdelen of -fasen, is elk onderdeel pas
              overeengekomen (en verschuldigd) als de Opdrachtgever ook daarvoor
              aan Noord Digital opdracht geeft.
            </p>
            <p data-id="element-740">
              Na het sluiten van de Overeenkomst kan de Opdrachtgever zonder
              toestemming van Noord Digital niet eenzijdig (onder)delen van het
              project wijzigen of delegeren aan derden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-741">
              Artikel 4 – Uitvoering van de Overeenkomst
            </h3>
            <p data-id="element-742">
              Noord Digital zal de Overeenkomst naar beste inzicht en vermogen
              uitvoeren. Dit betekent onder meer dat een inspanningsverplichting
              geldt voor de overeengekomen werkzaamheden en dat alle redelijke
              stappen worden gezet om het project succesvol te laten verlopen.
            </p>
            <p data-id="element-743">
              Alle door Noord Digital gecommuniceerde (oplever)termijnen zijn
              streefdata en niet bindend, tenzij uitdrukkelijk schriftelijk
              anders overeengekomen. Eventuele sancties bij overschrijding van
              termijnen (zoals boetes) zijn niet van toepassing, tenzij dit
              schriftelijk is overeengekomen.
            </p>
            <p data-id="element-744">
              Indien de Opdrachtgever niet op tijd informatie, content (teksten,
              afbeeldingen, video's, ontwerpen, etc.) of goedkeuring aanlevert,
              of als het project vertraging oploopt door gebrek aan
              besluitvorming of wijzigingen in de scope, kan dit leiden tot
              vertraging van het project. In een dergelijk geval zal Noord
              Digital in overleg met de Opdrachtgever de planning aanpassen.
            </p>
            <p data-id="element-745">
              Indien Noord Digital bij de uitvoering derden inschakelt (zoals
              hostingproviders, softwareleveranciers of freelancers), geschiedt
              dit voor eigen rekening en risico, tenzij anders vermeld in de
              Offerte.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-746">
              Artikel 5 – Oplevering en acceptatie
            </h3>
            <p data-id="element-747">
              De overeengekomen diensten of producten (bijvoorbeeld een website,
              applicatie of ontwerp) gelden als opgeleverd zodra Noord Digital
              de Opdrachtgever schriftelijk of per e-mail heeft bericht dat de
              werkzaamheden zijn afgerond, dan wel zodra het project feitelijk
              is gepubliceerd of in gebruik genomen door de Opdrachtgever.
            </p>
            <p data-id="element-748">
              Na oplevering heeft de Opdrachtgever maximaal 14 dagen de tijd om
              schriftelijk gebreken of bezwaren te melden. De melding moet
              duidelijk aangeven welke onderdelen niet voldoen aan de
              afgesproken specificaties.
            </p>
            <p data-id="element-749">
              Indien de Opdrachtgever binnen deze termijn geen schriftelijke en
              gespecificeerde bezwaren indient, wordt de oplevering geacht te
              zijn geaccepteerd. Na deze acceptatie is Noord Digital niet meer
              verplicht kostenloos wijzigingen aan te brengen buiten de reeds
              overeengekomen scope.
            </p>
            <p data-id="element-750">
              Na acceptatie vallende wijzigingen, aanvullingen of verbeteringen
              onder meerwerk (artikel 7) tenzij sprake is van een aan Noord
              Digital toerekenbaar verborgen gebrek dat reeds bij oplevering
              bestond.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-751">
              Artikel 6 – Verplichtingen van de Opdrachtgever
            </h3>
            <p data-id="element-752">
              De Opdrachtgever is verantwoordelijk voor tijdige en volledige
              aanlevering van alle benodigde materialen en informatie,
              waaronder:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-753">
              <li data-id="element-754">Teksten, afbeeldingen, video's en andere content;</li>
              <li data-id="element-755">Bedrijfsgegevens en logo's;</li>
              <li data-id="element-756">
                Toegang tot (test)omgevingen, beheerdersaccounts en systemen
                (inloggegevens voor hosting, CMS, API's, etc.);
              </li>
              <li data-id="element-757">
                Tussentijdse feedback en goedkeuringen. Indien deze gegevens
                niet tijdig worden verstrekt, kan de planning worden aangepast
                zoals in artikel 4.3 staat beschreven.
              </li>
            </ul>
            <p data-id="element-758">
              De Opdrachtgever garandeert dat alle door hem aangeleverde
              materialen vrij zijn van rechten van derden (auteursrechten,
              portretrechten, merkenrechten, e.d.). Bij het gebruik van
              afbeeldingen, teksten, video's of muziek moet de Opdrachtgever de
              nodige licenties of toestemmingen hebben. Indien hiervoor kosten
              aan verbonden zijn, draagt de Opdrachtgever deze kosten.
            </p>
            <p data-id="element-759">
              De Opdrachtgever vrijwaart Noord Digital volledig tegen alle
              aanspraken van derden, boetes, kosten en schadeclaims die
              voortvloeien uit door de Opdrachtgever aangeleverde of
              goedgekeurde content, websites of systemen. Dit omvat onder meer
              claims op grond van: auteursrechtinbreuk, merkenrecht,
              portretrecht, privacy/bescherming persoonsgegevens (AVG), cookie-
              of reclameregels, misleidende bewoordingen, of andere
              onrechtmatige inhoud. Ook eventuele kosten voor juridische
              verdediging komen voor rekening van de Opdrachtgever, tenzij
              duidelijk sprake is van grove nalatigheid of opzet van Noord
              Digital.
            </p>
            <p data-id="element-760">
              De Opdrachtgever is zelf verantwoordelijk voor de inhoud en het
              juridische gebruik van de opgeleverde website of software
              (bijvoorbeeld privacybeleid, cookieverklaringen, disclaimers).
              Noord Digital kan de opdrachtgever adviseren of informeren, maar
              is niet aansprakelijk voor naleving van regelgeving of
              effectiviteit van marketing/SEO.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-761">
              Artikel 7 – Wijzigingen en meerwerk
            </h3>
            <p data-id="element-762">
              Alle werkzaamheden die buiten de oorspronkelijk overeengekomen
              opdracht vallen, gelden als meerwerk. Dit geldt onder meer voor:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-763">
              <li data-id="element-764">
                Extra functionaliteiten of plug-ins die niet in de
                oorspronkelijke opdrachtomschrijving zijn opgenomen;
              </li>
              <li data-id="element-765">
                Nieuwe pagina's of secties op een website die niet waren
                begrepen in de oorspronkelijke briefing;
              </li>
              <li data-id="element-766">
                Aanvullende integraties met externe systemen of koppelingen
                (bijv. met CRM's, betaalproviders) die niet vooraf waren
                gespecificeerd;
              </li>
              <li data-id="element-767">
                Herhaalde revisierondes bovenop de in de Overeenkomst
                afgesproken revisielimiet.
              </li>
            </ul>
            <p data-id="element-768">
              Meerwerk wordt alleen uitgevoerd na voorafgaande schriftelijke
              instemming van de Opdrachtgever. Noord Digital zal aan de
              Opdrachtgever een nieuwe offerte of wijzigingsofferte sturen voor
              dit meerwerk, met een indicatie van de aanvullende kosten en
              (indien van toepassing) een nieuwe oplevertermijn. De
              Opdrachtgever dient deze offerte schriftelijk te accepteren
              voordat het meerwerk wordt verricht.
            </p>
            <p data-id="element-769">
              Revisies of aanpassingen die binnen de oorspronkelijke scope
              vallen worden kosteloos uitgevoerd. Indien echter naar het oordeel
              van Noord Digital het aantal verzoeken buitensporig wordt of
              duidelijk buiten de overeengekomen scope valt, is Noord Digital
              gerechtigd deze werkzaamheden als meerwerk te factureren.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-770">
              Artikel 8 – Betaling
            </h3>
            <p data-id="element-771">
              Voor projecten hanteert Noord Digital de volgende
              betalingsstructuur (exclusief btw):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-772">
              <li data-id="element-773">
                Projecten boven €2.000: 30% bij opdrachtbevestiging en start van
                de werkzaamheden; 70% bij oplevering.
              </li>
              <li data-id="element-774">
                Projecten tot €2.000: 100% voorafgaand aan aanvang van de
                werkzaamheden.
              </li>
            </ul>
            <p data-id="element-775">
              Facturen worden verzonden op het moment van opdrachtbevestiging of
              oplevering, afhankelijk van het hierboven bepaalde schema.
              Betaling dient te geschieden binnen 14 dagen na factuurdatum,
              tenzij schriftelijk anders is overeengekomen.
            </p>
            <p data-id="element-776">
              Bij niet-tijdige betaling is de Opdrachtgever van rechtswege in
              verzuim. Noord Digital is vanaf dat moment bevoegd wettelijke
              handelsrente in rekening te brengen (conform art. 6:119a BW).
              Tevens komen alle redelijke buitengerechtelijke incassokosten voor
              rekening van de Opdrachtgever (volgens de Wet normering
              buitengerechtelijke incassokosten).
            </p>
            <p data-id="element-777">
              In geval van wanbetaling behoudt Noord Digital zich het recht voor
              om alle openstaande werkzaamheden en diensten (inclusief hosting,
              onderhoud en support) per direct op te schorten totdat de betaling
              is voldaan. Dit betekent onder meer dat een website offline kan
              worden gehaald en dat toegang tot systemen wordt geblokkeerd. De
              Opdrachtgever blijft niettemin aansprakelijk voor de volledige
              overeengekomen vergoeding, inclusief in het werk gestoken uren.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-778">
              Artikel 9 – Abonnementen, looptijd en opzegging
            </h3>
            <p data-id="element-779">
              Hosting-, onderhouds- en andere periodieke diensten worden
              aangeboden op abonnementsbasis. De minimale looptijd van elk
              abonnement is 12 maanden, ingaande op de startdatum zoals vermeld
              in de offerte.
            </p>
            <p data-id="element-780">
              Na afloop van de initiële looptijd wordt het abonnement
              stilzwijgend verlengd voor onbepaalde tijd. Vanaf dat moment kan
              het abonnement door beide partijen maandelijks worden opgezegd met
              inachtneming van een opzegtermijn van één maand, tenzij
              schriftelijk anders is overeengekomen. Een opzegging dient
              schriftelijk of per e-mail te geschieden.
            </p>
            <p data-id="element-781">
              Bij tussentijdse beëindiging door de Opdrachtgever (bijvoorbeeld
              door opzegging voor het einde van de eerste jaarcontractperiode)
              blijft Noord Digital gerechtigd de overeengekomen bedrag(en) voor
              het resterende deel van de minimale contractduur (12 maanden) in
              rekening te brengen, tenzij partijen anders overeenkomen. Reeds
              betaalde abonnementskosten worden niet gerestitueerd.
            </p>
            <p data-id="element-782">
              Betaling van abonnementskosten geschiedt per automatische incasso
              of periodieke facturatie (verrekening), zoals overeengekomen in de
              offerte. Bij opzegging wordt geen terugbetaling verleend voor
              resterende looptijd, tenzij partijen anders schriftelijk zijn
              overeengekomen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-783">
              Artikel 10 – Hosting en infrastructuur
            </h3>
            <p data-id="element-784">
              Hosting door Noord Digital geschiedt via externe
              infrastructuurpartners en servers. De aangeboden hosting heeft een
              streef-uptime van 99,5% per maand. Deze uptime is echter geen
              harde garantie, maar een kwaliteitsdoelstelling.
            </p>
            <p data-id="element-785">
              Uptime-onderbrekingen door de volgende oorzaken vallen niet onder
              onze verantwoordelijkheid, en hebben derhalve geen recht op
              compensatie of claims: gepland onderhoud, netwerkstoringen, uitval
              van datacenters of cloudproviders, storingen bij gebruikte
              CDN-diensten (bijv. Cloudflare), DNS-problemen buiten onze
              control, of storingen in software van derden (bijv.
              hostingbeheerpanelen).
            </p>
            <p data-id="element-786">
              Noord Digital is niet aansprakelijk voor storingen veroorzaakt
              door externe partners of infrastructuur. Wel zullen wij bij
              meldingen van storingen direct onderzoeken of er aan onze kant
              ingegrepen kan worden.
            </p>
            <p data-id="element-787">
              Voor het registreren van domeinnamen en e-mailadressen treden wij
              slechts op als tussenpersoon. De Opdrachtgever blijft zelf
              verantwoordelijk voor het rechtmatig gebruik en tijdige verlenging
              van domeinen. Noord Digital kan niet aansprakelijk worden gesteld
              voor verlopen, geweigerde of betwiste domeinnamen (tenzij wij
              grove onzorgvuldigheid hebben begaan bij de aanvraag).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-788">
              Artikel 11 – Back-ups en dataverlies
            </h3>
            <p data-id="element-789">
              Noord Digital maakt dagelijks automatische back-ups van websites
              en bijbehorende data die op haar hostingomgeving staan. Deze
              back-ups worden tijdelijk bewaard en dienen als extra
              voorzorgsmaatregel.
            </p>
            <p data-id="element-790">
              Het maken van back-ups is een hulpmiddel en vormt géén garantie
              voor compleet herstel. De Opdrachtgever blijft te allen tijde zelf
              verantwoordelijk voor het veiligstellen van zijn eigen data en
              content (bijvoorbeeld via eigen opslag of versiebeheer).
            </p>
            <p data-id="element-791">
              In geval van een technisch probleem of fout in de hostingomgeving
              van Noord Digital zal herstel van de meest recente back-up worden
              uitgevoerd. Daarbij geldt dat herstel slechts valt onder de
              verplichtingen van Noord Digital indien de oorzaak volledig binnen
              eigen systeem lag.
            </p>
            <p data-id="element-792">
              Indien dataverlies of -beschadiging is veroorzaakt door
              handelingen of nalatigheden van de Opdrachtgever, door onbevoegde
              derden, of door storingen buiten onze infrastructuur (zoals eigen
              mailservers, externe databases, client-side opslag, etc.), dan kan
              herstel worden uitgevoerd als meerwerk tegen het gebruikelijke
              uurtarief van Noord Digital. No claims voor indirecte
              dataverliezen zijn in ieder geval uitgesloten (zie artikel 23).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-793">
              Artikel 12 – Beveiliging en cyberincidenten
            </h3>
            <p data-id="element-794">
              Noord Digital neemt redelijke technische en organisatorische
              maatregelen ter beveiliging van de door haar geleverde websites,
              applicaties en hostingomgevingen. Dit omvat standaard het gebruik
              van firewalls, SSL/TLS-certificaten, regelmatige software- en
              CMS-updates en monitoring op aanvallen.
            </p>
            <p data-id="element-795">
              Volledige beveiliging van internetdiensten kan echter nooit worden
              gegarandeerd. Noord Digital is daarom niet aansprakelijk voor
              schade of uitval veroorzaakt door cyberaanvallen (bijv. DDoS),
              malware, phishing, brute force-aanvallen, social engineering,
              zero-day exploits of andere (onvoorziene) inbraakmethoden.
            </p>
            <p data-id="element-796">
              Ook foutieve of achterhaalde software van derden (bijv. kwetsbare
              plugins, verouderde PHP-versies, verbreekte API-koppelingen) kan
              een risico vormen dat buiten onze verantwoordelijkheid valt.
            </p>
            <p data-id="element-797">
              Indien een beveiligingsincident mede is veroorzaakt door handelen
              of nalaten van de Opdrachtgever of door ingrepen van derden
              (bijvoorbeeld installatie van niet-goedgekeurde plug-ins of
              scripts), vervalt iedere aansprakelijkheid van Noord Digital voor
              de gevolgen daarvan. Eventuele herstelwerkzaamheden kunnen als
              meerwerk worden aangeboden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-798">
              Artikel 13 – Toegang en wachtwoorden
            </h3>
            <p data-id="element-799">
              De Opdrachtgever is volledig verantwoordelijk voor het beheer van
              gebruikersaccounts, rollen en wachtwoorden die hij aan derden of
              werknemers ter beschikking stelt.
            </p>
            <p data-id="element-800">
              Handelingen verricht met accounts of toegangen die aan of namens
              de Opdrachtgever zijn verstrekt, komen volledig voor rekening en
              risico van de Opdrachtgever. Indien een account wachtwoorden of
              API-sleutels onveilig worden bewaard of gewist, kan de
              Opdrachtgever daarvoor niet de aansprakelijkheid bij Noord Digital
              leggen.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-801">
              Artikel 14 – Software en diensten van derden
            </h3>
            <p data-id="element-802">
              Bij de uitvoering van onze diensten maken wij vaak gebruik van
              software, platforms en diensten van derde partijen (bijv.
              WordPress, thema's, plug-ins, API's, AI-tools, clouddiensten,
              licentiesoftware).
            </p>
            <p data-id="element-803">
              Noord Digital kan niet aansprakelijk worden gehouden voor
              storingen, fouten, wijzigingen in werking, beveiligingslekken of
              beëindiging van dienstverlening door deze derden. Dit geldt ook
              voor incompatibiliteit, prijswijzigingen of licentieproblemen van
              software van derden.
            </p>
            <p data-id="element-804">
              Eventuele kosten voor het aanschaffen of verlengen van licenties
              en abonnementen van derden kunnen separaat aan de Opdrachtgever
              worden doorberekend.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-805">
              Artikel 15 – Onderhoud
            </h3>
            <p data-id="element-806">
              Het onderhoudscontract kan bestaan uit (volgens de specificaties
              in de offerte):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-807">
              <li data-id="element-808">periodieke CMS-updates (bijv. nieuwe WordPress-versie);</li>
              <li data-id="element-809">plugin- of thema-updates;</li>
              <li data-id="element-810">controles op beveiliging en performance;</li>
              <li data-id="element-811">
                het doorvoeren van kleine verbeteringen in content of lay-out.
              </li>
            </ul>
            <p data-id="element-812">
              De concrete werkzaamheden en frequentie worden vastgelegd in de
              onderhoudsopdracht. Onderhoudswerkzaamheden die buiten de
              afgesproken routine vallen of waarvoor additionele content vereist
              is, worden als meerwerk beschouwd.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-813">
              Artikel 16 – Support
            </h3>
            <p data-id="element-814">
              Onder support valt de levering van ondersteuning aan de
              Opdrachtgever op werkdagen (ma t/m vr, 09:00–17:00) voor
              technische vragen en kleine correcties.
            </p>
            <p data-id="element-815">
              Support is geen 24/7-service, tenzij uitdrukkelijk schriftelijk
              anders is overeengekomen (bijvoorbeeld via een apart Service Level
              Agreement). Bij spoedstoringen zal Noord Digital weliswaar haar
              best doen snel te reageren, maar er bestaat geen garantie op
              directe bereikbaarheid of onmiddellijke oplossing buiten de
              reguliere uren.
            </p>
            <p data-id="element-816">
              Onder support vallen geen ingrijpende nieuwe functionaliteiten,
              herontwerp of uitbreiding van de overeengekomen scope. Dergelijke
              verzoeken worden als wijzigingsverzoek of meerwerk behandeld (zie
              artikel 7).
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-817">
              Artikel 17 – Intellectueel eigendom en overdracht
            </h3>
            <p data-id="element-818">
              Alle intellectuele eigendomsrechten (zoals auteursrecht,
              databankrecht, modelrecht) op door Noord Digital gemaakte
              ontwerpen, code, structuren, concepten, documentatie en workflows
              berusten bij Noord Digital. Deze rechten omvatten met name ook
              generieke programmeercomponenten, libraries, templates, technische
              methodieken en (AI-)prompts die door Noord Digital zijn
              ontwikkeld.
            </p>
            <p data-id="element-819">
              De Opdrachtgever verkrijgt na volledige betaling van de
              overeengekomen prijs een niet-exclusief, niet-overdraagbaar
              gebruiksrecht voor het doel waarvoor de Overeenkomst is gesloten.
              Dit gebruiksrecht geeft de Opdrachtgever het recht om de geleverde
              website, software of content in het kader van zijn eigen
              bedrijfsvoering te gebruiken. Verdere exploitatie (zoals verkoop
              aan derden of gewijzigde inzet) is niet toegestaan zonder
              schriftelijke toestemming.
            </p>
            <p data-id="element-820">
              Tenzij nadrukkelijk anders overeengekomen, zijn Noord Digital niet
              verplicht om broncode, projectbestanden, designbestanden,
              ontwikkelomgevingen, stagingomgevingen, repositories of interne
              documentatie over te dragen aan de Opdrachtgever. Als overdracht
              van broncode is afgesproken, geldt deze pas na volledige betaling.
            </p>
            <p data-id="element-821">
              Noord Digital behoudt zich het recht voor om generieke kennis,
              elementen en (onderdelen van) code die niet specifiek voor één
              klant zijn ontwikkeld, opnieuw te gebruiken voor andere projecten.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-822">
              Artikel 18 – Portfolio, marketing en geheimhouding
            </h3>
            <p data-id="element-823">
              Noord Digital behoudt zich het recht voor om informatie over het
              afgeronde project te gebruiken in haar portfolio, case studies en
              marketinguitingen. Dit kan onder meer het bedrijfsnaam, logo en
              screenshots van de opgeleverde website omvatten. Indien de
              Opdrachtgever hier bezwaren tegen heeft, dient dit vóór aanvang
              schriftelijk te worden gemeld; bij gebleken bezwaar kan de
              projectomschrijving worden aangepast.
            </p>
            <p data-id="element-824">
              Partijen verplichten zich tot geheimhouding van alle
              vertrouwelijke informatie die tijdens de samenwerking wordt
              verstrekt. Vertrouwelijke informatie omvat bedrijfsgeheimen,
              klantgegevens, prijsinformatie en niet-publieke projectdetails.
              Deze geheimhoudingsplicht geldt zowel tijdens de looptijd van de
              Overeenkomst als na beëindiging daarvan.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-825">
              Artikel 19 – Tevredenheidsgarantie
            </h3>
            <p data-id="element-826">
              Noord Digital streeft naar 100% tevredenheid bij design binnen de
              oorspronkelijke scope. Kosteloze revisies worden uitgevoerd zolang
              ze betrekking hebben op aspecten die binnen het projectplan en de
              offerte vallen (zoals lay-outcorrecties, kleine functionele
              aanpassingen of taalfouten).
            </p>
            <p data-id="element-827">
              De garantie geeft geen recht op onbeperkt herontwerp of
              inhoudelijke wijzigingen van het project buiten de originele
              opdrachtomschrijving. Uitgebreide nieuwe functionaliteiten of
              strategiewijzigingen worden als meerwerk gefactureerd.
            </p>
            <p data-id="element-828">
              Indien na vier revisierondes nog geen overeenstemming is bereikt,
              kan Noord Digital besluiten de opdracht naar billijkheid af te
              ronden of de samenwerking te beëindigen. In dat geval blijven
              reeds verrichte werkzaamheden in bezit van Noord Digital. Noord
              Digital is niet aansprakelijk voor gevolgen verbonden aan het
              beëindigen van de samenwerking.
            </p>
            <p data-id="element-829">
              Nadat de wederpartij akkoord geeft op het design voor de website
              staat Noord Digital in zijn recht de aanbetaling te behouden.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-830">
              Artikel 20 – Resultaten en garanties (SEO, performance, marketing)
            </h3>
            <p data-id="element-831">
              Noord Digital kan geen garanties geven voor resultaten buiten haar
              invloedssfeer. Dit geldt in het bijzonder voor (maar is niet
              beperkt tot):
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-832">
              <li data-id="element-833">Posities in zoekmachines (SEO-resultaten);</li>
              <li data-id="element-834">
                Bezoekersstatistieken, conversieratio's of marketing-KPI's;
              </li>
              <li data-id="element-835">
                Omzet, leads of rendement uit advertenties of
                marketingcampagnes;
              </li>
              <li data-id="element-836">
                Laadsnelheid of performance in specifieke browsers en op alle
                apparaten;
              </li>
              <li data-id="element-837">
                Compatibiliteit met toekomstige softwareversies of -platforms
                van derden.
              </li>
            </ul>
            <p data-id="element-838">
              Elke bepaling of indicatie over dit soort resultaten is dan ook
              indicatief en niet bindend.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-839">
              Artikel 21 – Domeinnamen en e-mail
            </h3>
            <p data-id="element-840">
              Als partij die domeinnamen registreert, treedt Noord Digital
              slechts op als bemiddelaar of wederverkoper via externe
              registrars. De Opdrachtgever blijft te allen tijde zelf
              verantwoordelijk voor keuze, gebruik en actualisering van
              domeinnamen (registratie, verlenging, verhuizing, etc.).
            </p>
            <p data-id="element-841">
              Noord Digital is niet aansprakelijk voor intrekking, verlies,
              verloop of weigering van een domeinnaam, noch voor merkrechtelijke
              geschillen rondom domeinnamen. Evenmin voor fouten of vertragingen
              die registrars of registries maken. Fouten in e-mailinstellingen
              of verlies van e-mail door derde partijen vallen eveneens buiten
              onze verantwoordelijkheid.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-842">
              Artikel 22 – Beëindiging van de Overeenkomst
            </h3>
            <p data-id="element-843">
              Beide partijen kunnen de Overeenkomst beëindigen bij wezenlijke
              tekortkoming door de wederpartij. Onder wezenlijke tekortkoming
              valt onder meer: niet of niet tijdig betalen van facturen, het
              niet nakomen van belangrijke contractbepalingen, of het onmogelijk
              maken van een normale voortgang. Voorbehoudt uitdrukkelijk dat
              sprake moet zijn van een tekortkoming die niet binnen een daartoe
              gestelde redelijke hersteltermijn wordt verholpen.
            </p>
            <p data-id="element-844">
              Noord Digital mag de Overeenkomst met onmiddellijke ingang
              beëindigen of opschorten als de Opdrachtgever niet aan zijn
              betalingsverplichtingen voldoet, in staat van faillissement wordt
              verklaard, surseance van betaling aanvraagt of anderszins
              insolvent raakt. In dat geval is Noord Digital gerechtigd alle
              (lopende en nog niet betaalde) werkzaamheden af te ronden en
              onmiddellijk de volledige overeengekomen vergoeding in rekening te
              brengen.
            </p>
            <p data-id="element-845">
              Als de Overeenkomst beëindigd wordt, blijft de Opdrachtgever
              aansprakelijk voor alle reeds verrichte werkzaamheden en gemaakte
              kosten tot de datum van beëindiging. Dit geldt zowel bij
              beëindiging door de Opdrachtgever als door Noord Digital.
            </p>
            <p data-id="element-846">
              Bij beëindiging van onderhouds- of hostingdiensten kan de
              Opdrachtgever verzoeken om migratie of overdracht van de website
              en data naar een andere leverancier. Noord Digital voert een
              dergelijke migratie slechts uit tegen vergoeding (meerwerk) en pas
              nadat alle openstaande facturen zijn voldaan.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-847">
              Artikel 23 – Aansprakelijkheid
            </h3>
            <p data-id="element-848">
              Noord Digital is alleen aansprakelijk voor directe schade die het
              rechtstreekse en exclusieve gevolg is van een aan Noord Digital
              toe te rekenen tekortkoming in de uitvoering van de Overeenkomst.
            </p>
            <p data-id="element-849">
              Indirecte schade en gevolgschade, zoals gederfde winst,
              omzetverlies, gemiste besparingen, bedrijfsschade,
              reputatieschade, verlies van data of klanten, is uitdrukkelijk
              uitgesloten. Ook is Noord Digital niet aansprakelijk voor schade
              door claims van derden (bijv. wegens hackers of datalekken) als
              hiervoor in redelijkheid de Opdrachtgever verantwoordelijk is.
            </p>
            <p data-id="element-850">
              Indien Noord Digital aansprakelijk wordt gehouden, is de
              schadevergoeding beperkt tot het bedrag dat de Opdrachtgever in de
              12 maanden voorafgaand aan het schadeveroorzakende incident aan
              Noord Digital heeft betaald voor de betreffende dienst. Indien
              Noord Digital een lagere verzekeringsuitkering ontvangt voor deze
              schade, geldt dat verzekeringsbedrag als maximum.
            </p>
            <p data-id="element-851">
              Eventuele claims of vorderingen tot schadevergoeding vervallen als
              zij niet binnen 12 maanden na ontdekking van de schade
              schriftelijk bij Noord Digital zijn gemeld.
            </p>
            <p data-id="element-852">
              Bovenstaande beperkingen en uitsluitingen gelden niet voor schade
              veroorzaakt door opzet of grove schuld (bewuste roekeloosheid) van
              Noord Digital. In zulke gevallen is Noord Digital aansprakelijk
              conform de wettelijke regels.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-853">
              Artikel 24 – Overmacht
            </h3>
            <p data-id="element-854">
              Noord Digital is niet aansprakelijk voor het niet, niet tijdig of
              niet volledig nakomen van verplichtingen indien dit het gevolg is
              van omstandigheden buiten haar macht ("overmacht"). Onder
              overmacht wordt in ieder geval verstaan: internetstoringen; uitval
              van servers, stroom of netwerk; DDoS-aanvallen en andere
              cyberincidenten; storingen bij (cloud)hostingpartijen, registrars
              of softwareleveranciers; pandemieën, overheidsmaatregelen, brand,
              oorlog of onverwachte calamiteiten.
            </p>
            <p data-id="element-855">
              Bij overmacht mag Noord Digital haar verplichtingen opschorten
              zolang de toestand van overmacht voortduurt. Als de (dreigende)
              overmacht langer dan twee maanden voortduurt, is elke partij
              bevoegd de Overeenkomst te ontbinden zonder dat er recht op
              schadevergoeding ontstaat.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-856">
              Artikel 25 – Deelbaarheid
            </h3>
            <p data-id="element-857">
              Indien een of meer bepalingen van deze Algemene Voorwaarden nietig
              of vernietigbaar blijken te zijn, tast dit niet de geldigheid van
              de overige bepalingen aan. Partijen verplichten zich in dat geval
              in goed overleg een nieuwe, geldige regeling ter vervanging
              overeen te komen die zoveel mogelijk de strekking van de
              oorspronkelijke bepaling benadert.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-858">
              Artikel 26 – Privacy en AVG
            </h3>
            <p data-id="element-859">
              Noord Digital verwerkt persoonsgegevens in overeenstemming met de
              Algemene Verordening Gegevensbescherming (AVG) en de
              Uitvoeringswet AVG.
            </p>
            <p data-id="element-860">
              Wanneer Noord Digital in het kader van de dienstverlening
              persoonsgegevens verwerkt voor rekening van de Opdrachtgever,
              treedt Noord Digital op als verwerker. Indien de wet dit vereist,
              wordt hiervoor een aparte verwerkersovereenkomst gesloten met de
              Opdrachtgever (art. 28 AVG).
            </p>
            <p data-id="element-861">
              De Opdrachtgever is zelf verantwoordelijk voor de rechtmatige
              verwerking van persoonsgegevens via de geleverde website of
              software (bijv. privacyverklaring, toestemmingen,
              beveiligingsmaatregelen). Noord Digital kan hiertoe advies geven,
              maar de (eind)verantwoordelijkheid blijft bij de Opdrachtgever.
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-862">
              Artikel 27 – Toepasselijk recht en geschillen
            </h3>
            <p data-id="element-863">
              Op alle rechtsbetrekkingen tussen Partijen is uitsluitend het
              Nederlands recht van toepassing. Dit betekent dat de Nederlandse
              wet, inclusief het Burgerlijk Wetboek, de
              Richtlijnen/Verordeningen van de EU (zoals de eIDAS/AVG), en de
              jurisprudentie van Nederlandse rechters rechtskracht hebben.
            </p>
            <p data-id="element-864">
              Geschillen die voortvloeien uit de Overeenkomst of deze Algemene
              Voorwaarden zullen bij uitsluiting worden voorgelegd aan de
              bevoegde rechter in het arrondissement Noord-Holland (plaatselijk
              bevoegde rechtbank), tenzij dwingend recht anders voorschrijft.
              Partijen doen hiermee uitdrukkelijk afstand van het recht
              eventuele geschillen in het buitenland te laten beslechten.
            </p>

            <h2 className="text-3xl font-bold mt-16 mb-6 border-b pb-4" data-id="element-865">
              Service Level Agreement (SLA) (Hosting en Support)
            </h2>
            <ul className="list-disc pl-6 space-y-2" data-id="element-866">
              <li data-id="element-867">
                <strong data-id="element-868">Werkdagen:</strong> ma–vr, 09:00–17:00; geen
                weekend/feestdagen.
              </li>
              <li data-id="element-869">
                <strong data-id="element-870">SLA-reactietijden (streefwaarden):</strong>
                <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-871">
                  <li data-id="element-872">Kleine wijzigingen: reactie binnen 3 werkdagen.</li>
                  <li data-id="element-873">Middelgrote wijzigingen: reactie binnen 5 werkdagen.</li>
                  <li data-id="element-874">
                    Kritieke storingen (website offline): eerste reactie binnen
                    1 werkdag.
                  </li>
                </ul>
              </li>
              <li data-id="element-875">
                <strong data-id="element-876">Beveiliging & Monitoring:</strong> Firewall en
                malware-scans worden continu toegepast; netwerk- en
                infrastructuur-monitoring op servers. Updates voor CMS en
                plugins worden maandelijks doorgevoerd. Nieuwe
                veiligheidsmaatregelen worden geïmplementeerd op afroep.
              </li>
              <li data-id="element-877">
                <strong data-id="element-878">Back-ups:</strong> Dagelijks (24 uurs interval) worden
                back-ups gemaakt van websitebestanden en databases. Bij storing
                in onze hostingomgeving wordt een back-upherstel uitgevoerd.
                Voor herstelkosten zie artikel 11.
              </li>
              <li data-id="element-879">
                <strong data-id="element-880">Support:</strong> Ondersteuning vindt plaats via e-mail
                of ticketing (geen telefonische helpdesk). 24/7 support kan
                desgewenst worden ingekocht.
              </li>
            </ul>

            <h2 className="text-3xl font-bold mt-16 mb-6 border-b pb-4" data-id="element-881">
              Aanbiedingsclausule en administratieve afhandeling
            </h2>
            <p data-id="element-882">
              In de offerte of opdrachtbevestiging dient de volgende tekst te
              worden opgenomen:
            </p>
            <blockquote className="bg-gray-50 p-4 border-l-4 border-[#007AFF] italic my-4" data-id="element-883">
              "Deze offerte en alle daaruit voortvloeiende overeenkomsten zijn
              onderworpen aan de Algemene Voorwaarden van Noord Digital. Door
              ondertekening van deze offerte verklaart Opdrachtgever de Algemene
              Voorwaarden ontvangen te hebben (als bijlage of via [link naar
              pdf]) en hiermee akkoord te gaan."
            </blockquote>

            <p data-id="element-884">
              Daarnaast kan in de acceptatiemail of in het digitale contract het
              volgende worden opgenomen:
            </p>
            <blockquote className="bg-gray-50 p-4 border-l-4 border-[#007AFF] italic my-4" data-id="element-885">
              "Met het ondertekenen van dit document verklaart ondergetekende
              deze Algemene Voorwaarden te hebben gelezen, kunnen opslaan en
              onvoorwaardelijk te aanvaarden. Volgens Verordening (EU) 910/2014
              (eIDAS) heeft een (gekwalificeerde) elektronische handtekening
              dezelfde rechtsgevolgen als een handgeschreven handtekening."
            </blockquote>

            <p data-id="element-886">
              Een voorbeeld van een handtekeningregel voor een (papieren)
              opdrachtbevestiging:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg my-4 font-mono text-sm" data-id="element-887">
              <p data-id="element-888">________________________________________________________</p>
              <p data-id="element-889">
                [Naam opdrachtgever – Functie]
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Datum: _________
              </p>
            </div>

            <p data-id="element-890">
              Bij digitale accordering volstaat bijvoorbeeld: "Ik ga akkoord met
              de Algemene Voorwaarden van Noord Digital."
            </p>

            <h3 className="text-xl font-bold mt-8 mb-4" data-id="element-891">
              Implementatie en controle
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-892">
              <li data-id="element-893">
                <strong data-id="element-894">Terhandstelling:</strong> Zorg dat de Algemene
                Voorwaarden vóór of bij het sluiten van de overeenkomst
                beschikbaar zijn. Bij voorkeur: PDF als bijlage bij de offerte,
                of link naar pdf in de e-mail met offerte. Op deze wijze kan de
                Opdrachtgever de voorwaarden opslaan, wat vereist is om ze
                juridisch geldig te maken volgens art. 6:235 BW. De gebruiker
                heeft dan "redelijke mogelijkheid" gehad om ze te bestuderen.
              </li>
              <li data-id="element-895">
                <strong data-id="element-896">Expliciet akkoord:</strong> Laat de klant bij (digitaal)
                ondertekenen expliciet verklaren dat hij de AV heeft ontvangen
                en accepteert. Bijvoorbeeld door een checkbox ("Ik bevestig dat
                ik de Algemene Voorwaarden van Noord Digital heb ontvangen en ga
                akkoord") of door ondertekening van de offerte zelf. Dit biedt
                bewijs bij een eventuele geschil.
              </li>
              <li data-id="element-897">
                <strong data-id="element-898">Bewijsstukken bewaren:</strong> Archiveer de offerte,
                opdrachtbevestiging, e-mails, facturen en ander correspondentie
                zorgvuldig. Bewaar het document waarin de Opdrachtgever akkoord
                gaat met de AV. Deze kunnen dienen als bewijs van
                rechtsgeldigheid volgens art. 6:227 BW.
              </li>
              <li data-id="element-899">
                <strong data-id="element-900">Offerte sjabloon:</strong> Zorg dat het offerte- of
                ordersjabloon een clausule bevat waarin melding wordt gemaakt
                van de toepasselijkheid van deze voorwaarden (zie voorbeeldtekst
                hierboven). Gebruik bij voorkeur een formele passage
                "Ondertekend door [naam], in [plaats]".
              </li>
              <li data-id="element-901">
                <strong data-id="element-902">Check lijst:</strong> Controleer bij elke nieuwe klant
                of deze geen formele Beroeps- of handelsvereniging of ander
                orgaan heeft (bijv. IFPI, ggz) die afwijkende regels oplegt. Pas
                dan de voorwaarden aan waar nodig.
              </li>
            </ul>
          </div>
        </div>
      </main>

      <Footer data-id="element-903" />
    </div>;
}